module.exports = __webpack_public_path__ + "img/home_banner.7ef3635c.jpg";